import React from "react";
import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import PageHead from "@/components/PageHead";

export default function BillingCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 md:px-10 py-24 text-center" data-testid="billing-cancel-page">
      <PageHead title="Checkout cancelled | ChronoVaults" noindex />
      <XCircle className="w-10 h-10 text-white/40 mx-auto" strokeWidth={1.5} />
      <h1 className="font-serif text-4xl text-bone mt-6 leading-none">Checkout cancelled.</h1>
      <p className="text-white/60 mt-4 text-sm">
        No charge was made. Your credits and plan are unchanged.
      </p>
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/pricing">
          <Button
            data-testid="billing-cancel-retry"
            className="h-11 px-6 bg-terracotta hover:bg-terracotta/90 text-white rounded-sm"
          >
            Back to pricing
          </Button>
        </Link>
        <Link to="/dashboard">
          <Button
            data-testid="billing-cancel-dashboard"
            variant="outline"
            className="h-11 px-6 border-white/20 bg-transparent text-bone hover:bg-white/5 rounded-sm"
          >
            Back to dashboard
          </Button>
        </Link>
      </div>
    </div>
  );
}
